var config = {
    apiKey: '7eb7854942ef303cd395ea3118eac2ffe3f34d08',
    product: 'COMMUNITY',
    statement : {
    	description: 'For more information visit our',
    	name : 'privacy policy',
    	url: 'https://shop.stihl.co.uk/pages/privacy-policy',
    	updated : '04/01/2019'
  	},
  	initialState: 'OPEN',
    closeStyle: 'button',
    necessaryCookies: ['__cfduid*','_ab*','_landing_page','_orig_referrer*','_s','_secure_session_id*','_shopify_country*','_shopify_sa_p*','_shopify_sa_t*','_shopify_uniq*','_shopify_visit*','_shopify_y*','cart_currency*','cart_sig*','cart_ts*','cart*','checkout_token*','secret*','secure_customer_sig*','shopify_pay_redirect*','storefront_digest*','tracked_start_checkout','your_dealer'],
    text: {
        title: 'This site uses cookies.',
        acceptRecommended: 'ACCEPT RECOMMENDED COOKIES',
        rejectSettings: 'REJECT',
        intro: 'Some cookies are essential to the functioning of this website, while others help us to improve your experience. We recommend you accept all cookies.',
        necessaryTitle: 'STRICTLY NECESSARY COOKIES',
        necessaryDescription: 'These essential cookies are inherent to and/or enable this website\'s core functionality. The website cannot function properly without these cookies.',
        closeLabel :'SAVE &amp; CLOSE',
        thirdPartyTitle: 'Warning: Some cookies require your attention',
      thirdPartyDescription: 'Please visit our <a href="https://shop.stihl.co.uk/pages/privacy-policy">privacy policy page</a> to view details on Ve and Captify',
    },
    optionalCookies: [{
        	name: 'analytics',
        	label: 'GOOGLE ANALYTICS',
        	description: 'Google Analytics cookies are anonymised, but allow to see how visitors use our site. This helps us to offer you a better experience.',
        	cookies: ['_dc', '_ga', '_gaexp', '_gat*', '_gid', '_gtm_UA-131754319*', '__utma', '__utmb', '__utmc', '__utmt', '__utmv', '__utmz'],
        	recommendedState: 'on',
        	onAccept: function() {
              	dataLayer.push({'analytics_cookies': 'accepted'});
            	// Add no js Google Tag Manager
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PQL8R94');
                // End Google Tag Manager
        	},
        	onRevoke: function() {
            	// Disable GA
                window['ga-disable-UA-131754319-2'] = true;
                CookieControl.delete("_ga");
                CookieControl.delete("_gid");
                CookieControl.delete("_gali");
                CookieControl.delete("UA-131754319-2");
              	dataLayer.push({'analytics_cookies': 'revoked'});
        	}
		},
  		{
            name : 'marketing',
            label: 'MARKETING COOKIES',
            description: 'We use marketing cookies to help us improve the relevancy of advertising campaigns you receive.',
            cookies: ['__hssrc','__hstc','__hstc','__qca*','_adid*','_fbp','_fbq','_gads* ','_kuid*','_ngid*','_ssid*','_trid*','_uetsid*','.hotjar.com','.mediaplex.com*','1P_JAR*','Acb*','adnxs.com*','adtrc*','AID*','Anj*','APISID*','C','c_user*','CM*','cm*','CM14*','CONSENT*','datr*','ddid*','dpr*','DSID* ','DV_TRACK*','DV*','eud*','euds*','exchange_uid*','FLC* ','fr*','HSID*','hubspotutk','Icu*','intercom-lou-c5ke8zbr','intercom-session-c5ke8zbr','LOGIN_INFO*','mojo1*','mojo3*','mp_6d7c50ad560e01715a871a117a2fbd90_mixpanel','mp_hj_mixpanel','mp_mixpanel__c','NID*','OGPC*','oo*','optimizelyBuckets','optimizelyEndUserId','optimizelySegments','OTZ*','ouuid_last_update*','ouuid*','pcc_2*','pl*','PREF*','pvc_2*','rud*','ruds*','S*','SAPISID*','sb*','Sess*','SID*','SIDCC*','SSID*','svid*','TAID*','TDCPM*','TDID*','Token*','token*','TPC*','TTDOptOut*','uid*','uuid2*','ve-session-id*','ve.id],','VISITOR_INFO1_LIVE*','xs*','xs*','YSC*'],
            recommendedState: 'on',
        	onAccept : function(){
                // hot jar
          		(function(h,o,t,j,a,r){
                	h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                	h._hjSettings={hjid:1260208,hjsv:6};
                	a=o.getElementsByTagName('head')[0];
                	r=o.createElement('script');r.async=1;
                	r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                	a.appendChild(r);
              	})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
				// Add Facebook Pixel
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window,document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '2232724570329550');
                fbq('track', 'PageView');
                fbq('consent', 'grant');
                // End Facebook Pixel
              	dataLayer.push({'marketing_cookies': 'accepted'});
            },
            onRevoke: function() {
            	fbq('consent', 'revoke');
              	dataLayer.push({'marketing_cookies': 'revoked'});
            }
    }],
    rejectButton: true,
    position: 'LEFT',
    theme: 'LIGHT'
};

CookieControl.load(config);